// Context
import { DatepickerProvider } from '@/utils/hooks/datepicker/useDatepicker';
import type { DatepickerDataType } from '@/utils/hooks/datepicker/types';

// Components
import DatepickerContent from '@/components/base/Datepicker/DatepickerContent';
import type { DatepickerContentProps } from '@/components/base/Datepicker/DatepickerContent';

export type DatepickerProps = OptionalExceptFor<
    Omit<DatepickerDataType, 'isOpen'>,
    'timezone' | 'firstDayOfWeek'
> &
    DatepickerContentProps;

const Datepicker = ({
    date = null,
    periods = null,
    timezone = 'Europe/Paris',
    firstDayOfWeek = 1, // set default to monday
    placeholder,
    isLeftIcon = true,
    periodSelected = null,
    options,
    className = '',
    ...restProps
}: DatepickerProps) => {
    return (
        <DatepickerProvider
            defaultValues={{
                date,
                periods,
                periodSelected,
                timezone,
                isOpen: false,
                firstDayOfWeek,
                options
            }}>
            <DatepickerContent
                isLeftIcon={isLeftIcon}
                placeholder={placeholder}
                className={className}
                {...restProps}
            />
        </DatepickerProvider>
    );
};

export default Datepicker;
